import { render, staticRenderFns } from "./VersaoLoader.vue?vue&type=template&id=03e01c14"
import script from "./VersaoLoader.vue?vue&type=script&lang=js"
export * from "./VersaoLoader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports